module.exports = __webpack_public_path__ + "static/media/4.130e84b8.png";